import NotFoundPage from "../pages/NotFoundPage";
import {useAppSelector} from "../hooks";
import {UserRole} from "../api/userApi";
import React from "react";
import {Outlet} from "react-router-dom";
import {isArray, isObject} from "underscore";

type ProtectedRouteProps = {
    allowedRoles: UserRole[] | 'all' | {except: UserRole[]}
    element?: JSX.Element
}

const ProtectedRoute = ({allowedRoles, element}: ProtectedRouteProps) => {
    const {role} = useAppSelector(state => state.user);

    const Element = element ? element : <Outlet/>

    if (isObject(allowedRoles) && !isArray(allowedRoles)) {
        return !allowedRoles.except.includes(role) ? Element : <NotFoundPage/>;
    }

    if (allowedRoles === 'all') {
        return Element
    }

    return allowedRoles.includes(role) ? Element : <NotFoundPage/>;
};

export default ProtectedRoute;
